export type CreditGroup = 'ai' | 'calls' | 'sms' | 'reveal';

export const CREDIT_GROUPS: { key: CreditGroup; label: string; color: string }[] = [
  { key: 'ai', label: 'AI', color: '#6D4AC7' },
  { key: 'calls', label: 'Calling', color: '#1F7A99' },
  { key: 'sms', label: 'Texting', color: '#B83B7A' },
  { key: 'reveal', label: 'Data reveal', color: 'var(--ant-color-text)' },
];
